import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import * as L from 'leaflet';

@Component({
  selector: 'app-add-missing-charger-map-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './add-missing-charger-map-dialog.component.html',
  styleUrl: './add-missing-charger-map-dialog.component.scss'
})
export class AddMissingChargerMapDialogComponent implements OnInit {
  private map: L.Map | undefined;

  dialogRef = inject(MatDialogRef<AddMissingChargerMapDialogComponent>);

  userLocation = {
    latitude: 37.0902,
    longitude: -95.7129,
  };
  resetButton = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { latitude: number; longitude: number }
  ) {
    this.userLocation = {
      latitude: data.latitude,
      longitude: data.longitude,
    };
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.initMap();
    }, 100);
  }

  initMap(): void {
    this.map = L.map('mapSelector', {
      attributionControl: false,
    }).setView([this.userLocation.latitude, this.userLocation.longitude], 17);

    const tileLayerUrl = `https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`;
    L.tileLayer(tileLayerUrl).addTo(this.map);

    this.map.on('moveend', () => {
      if (this.map.getCenter().lat !== this.userLocation.latitude || this.map.getCenter().lng !== this.userLocation.longitude) {
        this.resetButton = true;
      } else {
        this.resetButton = false;
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  resetMap() {
    this.map?.setView([this.userLocation.latitude, this.userLocation.longitude], 17);
    this.resetButton = false;
  }

  save() {
    this.dialogRef.close({
      latitude: this.map?.getCenter().lat,
      longitude: this.map?.getCenter().lng,
    });
  }
}
